// extracted by mini-css-extract-plugin
module.exports = {"texts":"introModal-5697d8ff18051e69aa46a3af22225f39","img":"introModal-ebc3654434614efa049f9aac2b295575","title":"introModal-7f4564e4d6e257b8783a5b8bad5183db"};